import QuizFeedReportData from './QuizFeedReportData';

export default QuizFeedReportData;
